<script setup>
import {ref, toRef, computed} from "vue";
import {useRouter} from "vue-router";
import {useLoginStore, useLanguageStore} from "@/pinia";

const loginStore = useLoginStore();
const languageStore = useLanguageStore();
const loginStatus = toRef(loginStore.getLoginStatus)
const emits = defineEmits(['fn_logout', 'set_menuModalStatus'])
const router = useRouter();

// 권한 체크 - USER는 메뉴 아이콘 숨김
const userRole = computed(() => loginStore.loginInfo?.role)
const canShowMenu = computed(() => userRole.value === 'ADMIN' || userRole.value === 'EDITOR')



const clickedMenu=()=>{
  emits('set_menuModalStatus', true)
}
const fn_logout=()=>{
  emits('fn_logout')
  router.push("/login");
}

</script>

<template>
  <div class="loginStatusBox">
    <template v-if="loginStatus === true">

      <div @click="fn_logout" class="menuButton">
        <v-icon>mdi-logout</v-icon>
        {{ languageStore.get('logout') }}
      </div>
      <div v-if="canShowMenu" class="menuButton" @click="clickedMenu">
        <v-icon>mdi-menu</v-icon>
        {{ languageStore.get('menu') }}
      </div>
    </template>
    <template v-else>
      <router-link to="/login">
        <div class="menuButton">
          <v-icon>mdi-login</v-icon>
          {{ languageStore.get('login') }}
        </div>
      </router-link>
    </template>
  </div>
</template>

<style scoped>
  .loginStatusBox{
    width: 10vw ;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .menuButton{
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor : pointer;
  }
</style>